import React from 'react';
import { Activity, ActivityKind } from '../activitiesTypes';
import styles from './ActivityCard.module.css';

interface ActivityCardProps {
  activity: Activity;
  onMarkComplete?: (id: string) => void;
}

const icons: Record<ActivityKind, string> = {
  Call: '📞',
  Visit: '📍',
  Meeting: '📅',
  Note: '📝',
  'Follow-Up': '🔁',
  Pricing: '💲',
  Collection: '💵',
  'New Account': '🆕',
  Display: '🖼️',
  Other: 'ℹ️',
};

const kindKey: Record<ActivityKind, string> = {
  Call: 'call',
  Visit: 'visit',
  Meeting: 'meeting',
  Note: 'note',
  'Follow-Up': 'default',
  Pricing: 'default',
  Collection: 'default',
  'New Account': 'default',
  Display: 'default',
  Other: 'default',
};

const priorityLabel: Record<NonNullable<Activity['priority']>, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

export const ActivityCard: React.FC<ActivityCardProps> = ({ activity, onMarkComplete }) => {
  return (
    <div className={styles.row}>
      <span className={`${styles.icon} ${styles[kindKey[activity.kind]]}`}>
        {icons[activity.kind]}
      </span>
      <div className={styles.body}>
        <div className={styles.headerRow}>
          <p className={styles.customer}>{activity.customer}</p>
          <span className={styles.timestamp}>{activity.timestamp}</span>
        </div>
        <p className={styles.title}>{activity.title}</p>
        <div className={styles.notes}>{activity.notes}</div>
        <div className={styles.metaRow}>
          {activity.priority && (
            <span className={`${styles.priorityBadge} ${styles[`priority_${activity.priority}`]}`}>
              {priorityLabel[activity.priority]} priority
            </span>
          )}
          {activity.completed && <span className={styles.completedBadge}>✓ Completed</span>}
        </div>
        {activity.followUp && (
          <p className={styles.followUp}>📅 Follow-up: <span>{activity.followUp}</span></p>
        )}
        {!activity.completed && onMarkComplete && (
          <button type="button" className={styles.markCompleteBtn} onClick={() => onMarkComplete(activity.id)}>
            Mark Complete
          </button>
        )}
      </div>
    </div>
  );
};
